/*
 * Cart page. Quantity changes and removals through the Cart AJAX API, with the
 * section re-rendered from the same response.
 *
 * The form underneath works without any of this: every control is a real named
 * submit and posts to /cart. Everything here is an upgrade layered on top, and
 * if it fails it falls back to submitting that form rather than leaving the
 * customer looking at a quantity that did not change.
 */
(function () {
  'use strict';

  var GENERIC = 'The cart could not be updated. Refresh the page and try again.';

  function root() {
    return document.querySelector('calmlyte-cart');
  }

  function toast(message, tone) {
    if (window.calmlyteToast) window.calmlyteToast(message, tone || 'error');
    else if (window.console) console.warn('[calmlyte] cart:', message);
  }

  function busy(on) {
    var el = root();
    if (el) el.toggleAttribute('data-busy', !!on);
  }

  /* Re-render this section from the change response rather than reloading the
     page: a reload loses the scroll position and, on a slow connection, shows
     an empty page in between. */
  function apply(html) {
    var el = root();
    if (!el || !html) return false;

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('calmlyte-cart');
    if (!next) return false;

    el.innerHTML = next.innerHTML;
    return true;
  }

  function change(key, quantity, fallbackForm) {
    var el = root();
    var sectionId = el ? el.dataset.sectionId : null;

    var payload = { id: key, quantity: quantity };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
    }

    busy(true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        busy(false);

        if (!result.ok) {
          throw new Error((result.data && result.data.description) || GENERIC);
        }

        var sections = result.data.sections || {};
        var html = sectionId ? sections[sectionId] : null;

        if (!apply(html)) {
          /* The section did not come back, so the page and the cart now
             disagree. Reloading is the only way to make them agree again. */
          window.location.reload();
          return;
        }

        document.dispatchEvent(new CustomEvent('calmlyte:cart:changed'));
      })
      .catch(function (err) {
        busy(false);
        /* Hand the work back to the form that would have done it anyway. */
        if (fallbackForm) {
          fallbackForm.submit();
          return;
        }
        toast(err.message || GENERIC, 'error');
      });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    change(remove.dataset.key, 0, remove.form);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;

    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) {
      toast(GENERIC, 'error');
      input.value = input.defaultValue;
      return;
    }
    change(input.dataset.key, quantity, input.form);
  });

  /* The Update button is redundant once quantities apply on change, but it
     stays in the markup for the no-JS path, so it is wired rather than left to
     submit the form and reload. */
  document.addEventListener('click', function (event) {
    var update = event.target.closest('[data-cart-update]');
    if (!update) return;
    event.preventDefault();

    var form = update.form;
    if (!form) return;

    var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-cart-qty]'));
    var changed = inputs.filter(function (input) {
      return input.value !== input.defaultValue;
    });

    if (changed.length === 0) return;
    if (changed.length === 1) {
      change(changed[0].dataset.key, parseInt(changed[0].value, 10), form);
      return;
    }
    /* More than one line edited at once: /cart/update.js takes them together,
       which /cart/change.js cannot do without one request per line. */
    var updates = {};
    changed.forEach(function (input) {
      updates[input.dataset.key] = parseInt(input.value, 10);
    });

    busy(true);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        busy(false);
        if (!res.ok) throw new Error(GENERIC);
        window.location.reload();
      })
      .catch(function () {
        busy(false);
        form.submit();
      });
  });
})();
